<script setup></script>

<template>
  <div>
    <p style="color: rgba(0, 0, 0, 0.56)" class="text-[#000]">
      Curabitur pretium quam ac consequat tempor. Curabitur vestibulum neque nec
      nisi pulvinar egestas. Curabitur volutpat, lorem eget porta gravida,
      libero ex pharetra sem, dictum semper leo nibh vitae massa. Nam orci
      sapien, gravida id est non, consequat tempor justo. Nullam non nisl
      facilisis, tristique lacus in, luctus arcu. Sed scelerisque dui eget
      facilisis semper.
    </p>
  </div>
</template>
